<template>
  <div id="app">
    <transition enter-active-class="animated fadeIn faster">
      <router-view></router-view>
    </transition>

    <!--Modals-->
    <ForgotPassword></ForgotPassword>
    <TermsAndConditionModal></TermsAndConditionModal>
    <PrivacyModal></PrivacyModal>
  </div>
</template>

<script>
import TermsAndConditionModal from "@/components/modal/TermsAndConditions.vue";
import PrivacyModal from "@/components/modal/Privacy.vue";
import ForgotPassword from "@/components/modal/ForgotPasswordModal.vue";

export default {
  name: "app",
  components: {
    TermsAndConditionModal,
    PrivacyModal,
    ForgotPassword,
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
};
</script>

<style lang="scss">
@import "./assets/scss/theme.scss";
@import "~animate.css/animate.css";

#app {
  font-family: $page-font;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $primary;
  background-color: $yellow;
}

a {
  color: $primary;
}

</style>
